export default "__VITE_ASSET__CMVxQ468__"